import {useSelector} from 'react-redux'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {useProductReview} from '../../../context/ProductReviewContext'
import {ProductReviewField} from '../../ui/ProductReviewField'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {
  getProductReviewFieldsForCountry,
  isFieldOptionalForLanguage,
  PRODUCT_REVIEW_DISPLAY_INFORMATION_SECTION,
} from '../productReviewDataMap'

/**
 * @param {{language: {code: string, language: string}}} props
 */
export const DisplayLanguageSection = ({language}) => {
  const {productData, updateEditableField} = useProductReview()
  const countryCode = useSelector(selectCountryCode)

  return (
    <ProductReviewSection title={`Language: ${language.language}`}>
      <div className="divide-y divide-[var(--secondary-800)]">
        {getProductReviewFieldsForCountry(PRODUCT_REVIEW_DISPLAY_INFORMATION_SECTION.fields, countryCode).map(field => {
          const sourceData = productData?.[field.source] ?? {}
          const value = sourceData?.[field.key]?.[language.code]

          return (
            <div key={`${language.code}-${field.key}`}>
              <ProductReviewField
                label={field.label}
                labelKey={field.key}
                editable={field.editable}
                required={field.required && !isFieldOptionalForLanguage(field, countryCode, language.code)}
                renderer={field.renderer}
                value={value}
                onChange={nextValue => updateEditableField(field.source, field.key, nextValue, language.code)}
              />
            </div>
          )
        })}
      </div>
    </ProductReviewSection>
  )
}
